var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("app-sale-search", {
            staticStyle: { "flex-grow": "1" },
            attrs: { fancy: "", label: _vm.label },
            on: {
              input: function ($event) {
                return _vm.onInput($event)
              },
            },
          }),
          _c(
            "w-scroll-view",
            { style: { maxHeight: "150px" }, attrs: { tag: "w-list" } },
            _vm._l(_vm.items, function (item) {
              return _c(
                "w-list-item",
                { key: item.ComputedFriendlyID },
                [
                  _c(
                    "w-list-item-text",
                    [
                      _vm._v(
                        " " +
                          _vm._s(item.ComputedFriendlyID) +
                          " - " +
                          _vm._s(item.CompanyName)
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("remove-item"),
                              expression: "$ct('remove-item')",
                            },
                          ],
                          attrs: { flat: "" },
                          on: {
                            click: function ($event) {
                              return _vm.removeSale(item)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "times" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }